module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('router-view'), _c('form', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "download",
      "action": "",
      "method": "GET",
      "target": "downloadFrame"
    }
  }), _c('iframe', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "downloadFrame"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8399f25c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 610
// module chunks = 1